// useSortSessions.js

const getBaseSessionName = (name) => {
  return String(name || "")
    .replace(/\s*\([A-Z]\)\s*$/, "")
    .trim();
};

const getVariantRank = (name) => {
  const text = String(name || "");
  if (text.includes("(A)")) return 0;
  if (text.includes("(B)")) return 1;
  return 2;
};

const getPriorityRank = (name) => {
  const base = getBaseSessionName(name);
  if (base === "Masterclass") return 1;
  if (base === "Keynote") return 2;
  if (base === "Showcase") return 3;
  return 50;
};

const getArtRank = (name) => {
  return String(name || "").includes("Art") ? 1 : 0;
};

const getComparisonValue = (value) => {
  return String(value || "").trim();
};

const compareByPriority = (a, b) => getPriorityRank(a) - getPriorityRank(b);

const compareByBaseName = (a, b) => {
  const baseA = getBaseSessionName(a);
  const baseB = getBaseSessionName(b);
  if (baseA === baseB) return 0;
  return baseA.localeCompare(baseB);
};

const compareByVariant = (a, b) => getVariantRank(a) - getVariantRank(b);

const compareByArt = (a, b) => getArtRank(a) - getArtRank(b);

const compareSessions = (aRaw, bRaw) => {
  const a = getComparisonValue(aRaw);
  const b = getComparisonValue(bRaw);
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;

  const priorityDiff = compareByPriority(a, b);
  if (priorityDiff) return priorityDiff;

  const baseDiff = compareByBaseName(a, b);
  if (baseDiff) return baseDiff;

  const variantDiff = compareByVariant(a, b);
  if (variantDiff) return variantDiff;

  const artDiff = compareByArt(a, b);
  if (artDiff) return artDiff;

  return 0;
};

export const useSortSessionNames = (sessions) => {
  const list = Array.isArray(sessions) ? [...sessions] : [];
  // list.forEach((name) =>
  //   console.log("Sorting sessions:", {
  //     name,
  //     base: getBaseSessionName(name),
  //     rank: getPriorityRank(name)
  //   })
  // );
  return list.sort(compareSessions);
};
